import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, mergeProps as _mergeProps, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "d-flex align-center" }
const _hoisted_2 = {
  key: 0,
  class: "font-weight-bold text-h5 text-primary"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "font-weight-bold pl-1" }, "Applications", -1)
const _hoisted_4 = {
  style: {"height":"80px"},
  class: "d-flex flex-column justify-space-between text-center align-center"
}
const _hoisted_5 = {
  style: {"height":"80px"},
  class: "d-flex flex-column justify-space-between text-center align-center"
}
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption" }, "Account management", -1)
const _hoisted_7 = {
  style: {"height":"80px"},
  class: "d-flex flex-column justify-space-between text-center align-center"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "text-caption" }, "Admin", -1)
const _hoisted_9 = { class: "toast" }
const _hoisted_10 = {
  key: 0,
  class: "help"
}
const _hoisted_11 = { class: "d-flex align-center" }
const _hoisted_12 = {
  href: "https://get.support.daizy.io/servicedesk/customer/portal/3",
  class: "bottom-link"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_progress_linear = _resolveComponent("v-progress-linear")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_app_bar_nav_icon = _resolveComponent("v-app-bar-nav-icon")!
  const _component_v_img = _resolveComponent("v-img")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_avatar = _resolveComponent("v-avatar")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_menu = _resolveComponent("v-menu")!
  const _component_v_app_bar_title = _resolveComponent("v-app-bar-title")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_list_item = _resolveComponent("v-list-item")!
  const _component_v_list = _resolveComponent("v-list")!
  const _component_v_app_bar = _resolveComponent("v-app-bar")!
  const _component_router_view = _resolveComponent("router-view")!
  const _component_Toast = _resolveComponent("Toast")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", {
    class: "fill-height",
    key: _ctx.$vuetify.theme.themes.currentTheme
  }, [
    _createVNode(_component_v_app_bar, {
      color: "primary",
      height: "64"
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_progress_linear, {
          absolute: "",
          location: "bottom",
          indeterminate: _ctx.appStore.appLoading
        }, null, 8, ["indeterminate"]),
        _createVNode(_component_v_row, {
          "no-gutters": "",
          justify: "space-between"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_col, {
              cols: "auto",
              "align-self": "center"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_v_row, {
                  "no-gutters": "",
                  align: "center"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_col, { cols: "auto" }, {
                      default: _withCtx(() => [
                        (_ctx.userStore?.apps?.length > 1 || _ctx.userStore?.isManager || _ctx.userStore?.isSuperAdmin)
                          ? (_openBlock(), _createBlock(_component_v_menu, {
                              key: 0,
                              transition: "scale-transition",
                              "close-on-content-click": true
                            }, {
                              activator: _withCtx(({ props }) => [
                                _createElementVNode("div", _hoisted_1, [
                                  _createVNode(_component_v_app_bar_nav_icon, _mergeProps(props, { class: "ml-4" }), {
                                    default: _withCtx(() => [
                                      _createVNode(_component_v_icon, { size: "large" }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("mdi-dots-grid")
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 2
                                  }, 1040)
                                ])
                              ]),
                              default: _withCtx(() => [
                                _createVNode(_component_v_card, {
                                  class: "pa-3",
                                  width: "360"
                                }, {
                                  default: _withCtx(() => [
                                    (_ctx.tenantStore.tenant)
                                      ? (_openBlock(), _createBlock(_component_v_card_title, {
                                          key: 0,
                                          class: "px-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: _ctx.landscapeLogoSrc,
                                              "max-height": "50",
                                              "max-width": "300",
                                              class: "logo"
                                            }, null, 8, ["src"]),
                                            (!_ctx.tenantStore.tenantTheme.logo)
                                              ? (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_ctx.tenantStore.tenant.name), 1))
                                              : _createCommentVNode("", true)
                                          ]),
                                          _: 1
                                        }))
                                      : (_openBlock(), _createBlock(_component_v_card_title, {
                                          key: 1,
                                          class: "px-0"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_img, {
                                              src: _ctx.defaultLogo,
                                              "max-height": "50",
                                              "max-width": "300",
                                              class: "logo"
                                            }, null, 8, ["src"])
                                          ]),
                                          _: 1
                                        })),
                                    _createVNode(_component_v_row, null, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_col, {
                                          cols: "12",
                                          class: "pb-0 pt-6"
                                        }, {
                                          default: _withCtx(() => [
                                            _hoisted_3
                                          ]),
                                          _: 1
                                        }),
                                        _createVNode(_component_v_col, { cols: "12" }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_row, {
                                              align: "stretch",
                                              dense: ""
                                            }, {
                                              default: _withCtx(() => [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tenantStore.tenantApplications, (app) => {
                                                  return (_openBlock(), _createElementBlock(_Fragment, null, [
                                                    (!!_ctx.tenantStore.tenantId && (_ctx.userStore.apps.map((a) => a.id).includes(Number(app.id)) || _ctx.userStore?.isSuperAdmin))
                                                      ? (_openBlock(), _createBlock(_component_v_col, {
                                                          key: app.id,
                                                          class: "d-flex justify-center",
                                                          cols: "4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createVNode(_component_v_card, {
                                                              disabled: !(_ctx.userStore.apps.map((a) => a.id).includes(Number(app.id)) || _ctx.userStore?.isSuperAdmin),
                                                              onClick: ($event: any) => (_ctx.userStore.setLastActiveApplication(app.id)),
                                                              height: "100",
                                                              width: "105",
                                                              class: "pa-2 fill-height",
                                                              variant: _ctx.$route.path === `/applications/${app.id}` ? 'tonal' : 'flat',
                                                              color: _ctx.$route.path === `/applications/${app.id}` ? 'primary' : 'grey-lighten-4',
                                                              to: `/applications/${app.id}`
                                                            }, {
                                                              default: _withCtx(() => [
                                                                _createElementVNode("div", _hoisted_4, [
                                                                  _createVNode(_component_v_avatar, null, {
                                                                    default: _withCtx(() => [
                                                                      _createVNode(_component_v_icon, {
                                                                        class: _normalizeClass(!(_ctx.userStore.apps.map((a) => a.id).includes(Number(app.id)) || _ctx.userStore?.isSuperAdmin) ? 'text-disabled' : ''),
                                                                        size: "large",
                                                                        color: _ctx.$route.path === `/applications/${app.id}` ? 'primary' : 'grey-darken-1'
                                                                      }, {
                                                                        default: _withCtx(() => [
                                                                          _createTextVNode("mdi-" + _toDisplayString(app.icon ? app.icon : 'application'), 1)
                                                                        ]),
                                                                        _: 2
                                                                      }, 1032, ["class", "color"])
                                                                    ]),
                                                                    _: 2
                                                                  }, 1024),
                                                                  _createElementVNode("span", {
                                                                    class: _normalizeClass(["text-caption", !(_ctx.userStore.apps.map((a) => a.id).includes(Number(app.id)) || _ctx.userStore?.isSuperAdmin) ? 'text-disabled' : ''])
                                                                  }, _toDisplayString(app.name), 3)
                                                                ])
                                                              ]),
                                                              _: 2
                                                            }, 1032, ["disabled", "onClick", "variant", "color", "to"])
                                                          ]),
                                                          _: 2
                                                        }, 1024))
                                                      : _createCommentVNode("", true)
                                                  ], 64))
                                                }), 256)),
                                                ((_ctx.userStore?.isManager || _ctx.userStore?.isSuperAdmin) && _ctx.tenantStore.tenantId)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 0,
                                                      class: "d-flex justify-center",
                                                      cols: "4"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_card, {
                                                          "min-height": "80",
                                                          width: "105",
                                                          class: "pa-2",
                                                          to: "/manage",
                                                          variant: _ctx.$route.path.includes('manage') ? 'tonal' : 'flat',
                                                          color: _ctx.$route.path.includes('manage') ? 'primary' : 'grey-lighten-4'
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_5, [
                                                              _createVNode(_component_v_avatar, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "large",
                                                                    color: _ctx.$route.path.includes('manage') ? 'primary' : 'grey-darken-1'
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("mdi-account-cog")
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["color"])
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _hoisted_6
                                                            ])
                                                          ]),
                                                          _: 1
                                                        }, 8, ["variant", "color"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true),
                                                (_ctx.userStore?.isSuperAdmin)
                                                  ? (_openBlock(), _createBlock(_component_v_col, {
                                                      key: 1,
                                                      class: "d-flex justify-center",
                                                      cols: "4"
                                                    }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_card, {
                                                          "min-height": "80",
                                                          width: "105",
                                                          class: "pa-2",
                                                          to: "/admin",
                                                          variant: _ctx.$route.path.includes('admin') ? 'tonal' : 'flat',
                                                          color: _ctx.$route.path.includes('admin') ? 'primary' : 'grey-lighten-4'
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createElementVNode("div", _hoisted_7, [
                                                              _createVNode(_component_v_avatar, null, {
                                                                default: _withCtx(() => [
                                                                  _createVNode(_component_v_icon, {
                                                                    size: "large",
                                                                    color: _ctx.$route.path.includes('admin') ? 'primary' : 'grey-darken-1'
                                                                  }, {
                                                                    default: _withCtx(() => [
                                                                      _createTextVNode("mdi-tools")
                                                                    ]),
                                                                    _: 1
                                                                  }, 8, ["color"])
                                                                ]),
                                                                _: 1
                                                              }),
                                                              _hoisted_8
                                                            ])
                                                          ]),
                                                          _: 1
                                                        }, 8, ["variant", "color"])
                                                      ]),
                                                      _: 1
                                                    }))
                                                  : _createCommentVNode("", true)
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_col, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_app_bar_title, {
                          class: "ml-4",
                          text: _ctx.$route.params.applicationId ? _ctx.getAppName(_ctx.$route.params.applicationId) : ''
                        }, null, 8, ["text"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_col, { cols: "auto" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_menu, {
                  transition: "scale-transition",
                  "close-on-content-click": true
                }, {
                  activator: _withCtx(({props}) => [
                    _createVNode(_component_v_btn, _mergeProps({ icon: "mdi-account" }, props, { class: "mr-4" }), null, 16)
                  ]),
                  default: _withCtx(() => [
                    _createVNode(_component_v_card, { width: "150" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_list, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showUserProfile = true)),
                              "prepend-icon": "mdi-card-account-details-outline",
                              title: "Profile"
                            }),
                            (_ctx.tenantStore.appHelp)
                              ? (_openBlock(), _createBlock(_component_v_list_item, {
                                  key: 0,
                                  href: _ctx.tenantStore.appHelp,
                                  "prepend-icon": "mdi-help-circle-outline",
                                  title: "Help"
                                }, null, 8, ["href"]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_v_list_item, {
                              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.userStore.userLogout())),
                              "prepend-icon": "mdi-logout-variant",
                              title: "Log out"
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }),
    _createVNode(_component_v_main, { class: "fill-height" }, {
      default: _withCtx(() => [
        (_openBlock(), _createBlock(_component_router_view, {
          class: "fill-height",
          key: _ctx.$route.params.applicationId
        })),
        _createElementVNode("div", _hoisted_9, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notificationStore.toastMessages, (message, key) => {
            return (_openBlock(), _createBlock(_component_Toast, {
              class: "mt-1",
              key: key,
              ref_for: true,
              ref: key,
              type: "error",
              heading: "An error occurred:",
              body: message,
              onUpdateShowToast: ($event: any) => (_ctx.checkRemoveNotification($event, key))
            }, null, 8, ["body", "onUpdateShowToast"]))
          }), 128))
        ]),
        (_ctx.$route.path.includes('admin'))
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _createElementVNode("a", _hoisted_12, [
                  _createVNode(_component_v_icon, {
                    class: "mr-1",
                    style: {"margin-top":"-2px"},
                    size: "20"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-help-circle")
                    ]),
                    _: 1
                  }),
                  _createTextVNode(" Help ")
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_v_dialog, {
      width: "500",
      modelValue: _ctx.showUserProfile,
      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.showUserProfile) = $event))
    }, {
      default: _withCtx(({ isActive }) => [
        _createVNode(_component_v_card, { title: "User details" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_text, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_form, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_row, { align: "center" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Name",
                              "hide-details": "",
                              density: "comfortable",
                              readonly: "",
                              "model-value": _ctx.fullName(_ctx.userStore.user.first_name, _ctx.userStore.user.last_name)
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_v_col, {
                          cols: "12",
                          class: "pb-0"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_text_field, {
                              label: "Email",
                              "hide-details": "",
                              density: "comfortable",
                              readonly: "",
                              "model-value": _ctx.userStore.user.email,
                              type: "email"
                            }, null, 8, ["model-value"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_card_actions, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_spacer),
                _createVNode(_component_v_btn, {
                  color: "grey",
                  onClick: ($event: any) => {isActive.value = false;}
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Close ")
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ]),
              _: 2
            }, 1024)
          ]),
          _: 2
        }, 1024)
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}